import styled from 'styled-components';

export const ButtonIconWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.small};
`;
